export const routes = {
  login: '/login',
  home: '/',
  admin: '/admin',
  adminModule: (moduleId: string) => `/admin/${moduleId}`,
  adminEmbed: (moduleId: string) => `/admin/embed/${moduleId}`,
} as const;
